import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FeedbackApi } from '../../api/api/FeedbackApi';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-opinion',
  templateUrl: './user-opinion.component.html',
  styleUrls: ['./user-opinion.component.css']
})
export class UserOpinionComponent implements OnInit {

  isFocused = false;
  isComplete = false;

  constructor(
    private api: FeedbackApi,
    private router: Router
  ) { }

  toggle() {
    this.isFocused = !this.isFocused;
  }

  sendFeedback(form: NgForm) {
    this.isComplete = true;
    this.api.feedback({
      page: this.router.url,
      text: form.value.feedback
    }).subscribe();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/user-opinion/user-opinion.component.ts